import StyledSvgIconWrapper, { TStyledSvgIconWrapper } from "./wrappers/StyledSvgIconWrapper";

export const CharityIcon: React.FC<TStyledSvgIconWrapper> = ({ active = false, monochrome, ...props }) => {
  return (
    <StyledSvgIconWrapper {...props} active={active} width="93px" height="82px" viewBox="0 0 93 82">
      <svg width="64" height="61" viewBox="0 0 64 61" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 40.5379L7.0011 37.1316L19.5827 54.4879L15.4184 58.0517"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={monochrome ? "stroke" : undefined}
        />
        <path
          d="M17.3087 51.3475C18.6869 50.0283 22.6445 46.2873 25.529 46.2183C28.4135 46.1396 34.7142 48.8075 38.9376 47.8723C44.5983 46.6121 54.4234 37.0726 60.0054 32.9082C60.8914 32.2486 63.0376 30.1517 61.4033 27.8579C59.651 25.4065 56.2644 26.8832 50.4363 29.4724C49.3533 29.9548 46.4294 31.2937 46.4294 31.2937"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={monochrome ? "stroke" : undefined}
        />
        <path
          d="M27.5372 38.7461H37.0473C40.867 38.7461 41.2707 36.2259 41.0245 34.8772C40.3649 31.2641 29.5653 29.8957 25.0662 29.9942C18.8246 30.1418 9.56071 39.7602 9.56071 39.7602"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={monochrome ? "stroke" : undefined}
        />
        <path
          d="M35.3343 20.809C35.3343 20.809 26.0999 16.1721 24.8693 10.029C24.0227 5.80557 26.2673 2.17286 29.7425 2.00549C33.2177 1.83813 35.2457 5.54961 35.2457 5.54961H35.3343C35.3343 5.54961 37.4608 1.83813 40.9261 2.00549C44.4013 2.17286 46.646 5.80557 45.7993 10.029C44.5687 16.1721 35.3343 20.809 35.3343 20.809Z"
          stroke="#32B88E"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="stroke"
        />
      </svg>
    </StyledSvgIconWrapper>
  );
};
